module.exports = __webpack_public_path__ + "img/des-action-hands.8936d67e.png";